import { ModelChangeListener } from "../../Forms/PublicForm/ModelChangeListener";
import { BindingPath } from "../Core/CoreTypes";

export type ModelChangeHooks = Map<ModelChangeListener, BindingPath[]>;

const ensureArray = (arg: BindingPath | BindingPath[]): BindingPath[] => (Array.isArray(arg) ? arg : [arg]);

export interface Subscription {
    unsubscribe: () => void;
}

export class ModelChangeEventListener {
    public modelChangeHookListener: ModelChangeHooks = new Map();

    public onModelChange(pathOrPaths: BindingPath | BindingPath[], listener: ModelChangeListener): Subscription {
        const pathArr = ensureArray(pathOrPaths);

        this.modelChangeHookListener.set(listener, pathArr);
        const removeSubscriber = () => {
            this.modelChangeHookListener.delete(listener);
        };
        return {
            unsubscribe: () => {
                removeSubscriber();
            },
        };
    }
}
